import Link from 'next/link';

import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const CrumbItem = styled(Link)<{ $isActive: boolean }>`
  align-items: center;
  color: ${({ $isActive }) => ($isActive ? Colors.blue[100] : Colors.gray[20])};
  display: flex;
  gap: ${Spacing['3Xs']};
  text-decoration: none;

  &:hover {
    color: ${Colors.blue[100]};
    cursor: pointer;
  }
`;

export const IconWrapper = styled.div`
  align-items: center;
  display: flex;
  svg {
    height: 1rem;
    width: 1rem;
  }
`;
